<template>
  <div>
    <div class="r-text-intro">פרטים אישיים</div>
    <div class="form">
      <div class="r-text-headline-paragraph">איזו תעודת זהות יש לך?</div>
      <select-buttons :options="options" size="lg" />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import WizardPage from '@/mixins/WizardPage';
import { mapState, mapMutations } from 'vuex';
import { SocialIdType } from '@/constants/meitav-dash/open-fund';
import Segment from '@/Segment';
import SelectButtons from '@/components/base/SelectButtons';

export default {
  name: 'ChooseSocialIdType',
  components: { SelectButtons },
  mixins: [WizardPage],
  computed: {
    ...mapState('meitavDash/openFund', ['socialIdType']),
    options() {
      return [
        {
          img: require('@/assets/common/standard-id.svg'),
          label: 'רגילה',
          action: this.setSocialIdTypeAndProceed,
          value: SocialIdType.STANDARD,
        },
        {
          img: require('@/assets/common/biometric-id.svg'),
          label: 'ביומטרית',
          action: this.setSocialIdTypeAndProceed,
          value: SocialIdType.BIOMETRIC,
        },
      ];
    },
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setSocialIdType', 'setSocialIdFiles']),
    async setSocialIdTypeAndProceed(selectedOption) {
      Segment.trackUserInteraction('Saving_SocialIdTypeClicked', { socialIdType: selectedOption.label });
      if (this.socialIdType !== selectedOption.value) {
        this.setSocialIdFiles(undefined);
      }
      this.setSocialIdType(selectedOption.value);
      await this.nextPage();
    },
  },
};
</script>
